import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {ReactComponent as BackSVG} from "../../../../images/icons/arrow-left.svg";
import {RootState} from "../../../../reducers";
import ErrorFormAlertView from "../../../components/Common/ErrorFormAlertView";
import ErrorFormView from "../../../components/Common/ErrorFormView";
import ErrorFormHelper from "../../../utils/ErrorFormHelper";
import {getUser} from "../../../services/User/reducer";
import {useAuth} from "../../../services/User/auth";

interface OwnProps {
    onHide: () => void,
    setPage: (page?: string) => void
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function UserDeleteDrawer(props: Props) {
    const {t} = useTranslation();
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([] as any[]);
    const authService = useAuth();

    const deleteAccount = async (event: React.FormEvent) => {
        event.preventDefault();

        setLoading(true);
        try {
            await authService.deleteUser(password);
            setLoading(false);
            props.onHide();
        } catch (e) {
            setErrors([{
                message: t("constraints.internal.account_removal_failed")
            }]);
            setLoading(false);
        }

    }
    return (
        <form onSubmit={deleteAccount}>
            <div className={"user"}>
                <div className={"user-header-top top"}>
                    <button onClick={() => props.setPage(undefined)} className={"btn-back"}
                            aria-label={t("common.action.close")} type="button">
                        <BackSVG/>
                    </button>
                    <h3>
                        {t("modules.user.action.remove_account.title")}
                    </h3>
                </div>
                <div className={"container px-0 mx-0 my-2"}>
                    <p>
                        {t("modules.user.field.remove_account_confirmation.title")}
                    </p>
                    <div>
                        <ErrorFormAlertView errors={errors}/>
                        <div className="form-group">
                            <input type="password" onChange={(e) => setPassword(e.target.value)} value={password}
                                   className={"form-control" + ErrorFormHelper(errors, "password")}
                                   autoComplete="new-password" name="remove_account_password"
                                   placeholder={t("modules.user.field.your_password.title")} id="password"
                                   aria-label={t("modules.user.field.your_password.title")}/>
                            <label htmlFor="password">
                                {t("modules.user.field.your_password.title")}
                            </label>
                            <ErrorFormView errors={errors} field="password"/>
                        </div>
                    </div>
                    <button
                        className={"btn-spinner btn-block btn-primary btn w-100 btn-submit" + (loading ? ' loading' : '')}
                        onClick={deleteAccount} type="submit">
                        <span className="left spinner-border spinner-border-sm"/>
                        {t("modules.user.action.remove_account.title")}
                    </button>
                </div>
            </div>
        </form>
    )
}

const mapStateToProps = (state: RootState) => ({
    user: getUser(state.user)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(UserDeleteDrawer));